import { Schema, arrayOf, normalize } from 'normalizr';

const featureSchema = new Schema('features');

const fabricatorSchema = new Schema('fabricators');

fabricatorSchema.define({
  features: arrayOf(featureSchema)
});

const stoneSupplierSchema = new Schema('stoneSupplierStones');

const stoneSchema = new Schema('stones');

stoneSchema.define({
  stoneSupplierStones: arrayOf(stoneSupplierSchema)
});

const orderedBySchema = new Schema('orderedBy');

orderedBySchema.define({
  fabricators: arrayOf(fabricatorSchema),
  stones: arrayOf(stoneSchema)
});

function assignFabricatorFeature(normalized, key, entity) {
  switch(key) {
    case 'features':
      normalized.fabricatorFeatures = entity;
      if('features' in normalized) {
        delete normalized.features;
      }
    break;
    case 'stoneSupplierStoneId':
    break;
    default:
      normalized[key] = entity;
  }
}

export const normalizeStoneModel = (obj, options = {}) => {
  const { result, entities } =
    normalize({ id: 'root', ...obj }, orderedBySchema, { ...options, assignEntity: assignFabricatorFeature });

  if (entities && entities.features) {
    entities.fabricatorFeatures = entities.features;
    delete entities.features;
  }

  entities.filterGroups = obj.filterGroups;
  return { result, entities };
};
